import {apiRequest, dataBaseUrl} from './apiRequest';

const deliveryScheduleOptions = ['None', 'Daily', 'Weekly', 'Monthly'];
const reportOptions = ['None','Company Sales', 'User Metrics'];
const deliveryMethod = ['Both', 'In-App'];
const recipientDefault = { type: 'customer', origin: 'none' };

const initializeState = {
  selectedSchedule: deliveryScheduleOptions[0],
  selectedReport: reportOptions[0],
  selectedMethod: deliveryMethod[0],
  subject: 'Hot Sauce Sale Items',
  attachments: [],
  recipientDesc: recipientDefault,
  memes: false
}

const generateBody = (offerings, company, account) => {
  let base_url;
  if (window.location.hostname === 'customer.hotsauceyourtops.com') {
    base_url = "https://public.hotsauceyourtops.com/offering/"
  } else {
    base_url = "https://public.staging.hotsauceyourtops.com/offering/"
  }

  console.log({offerings})
  let data = '<h3>Hot Sauce Sale Items</h3><ul>'
  offerings.map(o => (
    data += `<li><a href=\"` +
      `${base_url + o.id + '?company=' + company.customerId + '&account=' + account}` +
      `\" target=\"_blank\">${o.json_data.nickname || o.sales_option}</a></li>`))
  data += '</ul>'
  return data
}

export const prepMessageSend = async(recipient, offerings, sender, account) => {
  const data = {
    recipients: [recipient],
    body: generateBody(offerings, sender, account),
    senderUser: sender
  }
  const preppedData = Object.assign({...data}, initializeState)
  console.log({preppedData})
  await sendMessage(preppedData)
}

const sendMessage = async(data) => {
  try {
    let response = await apiRequest(dataBaseUrl, '/messages/', {
      method: 'post',
      data,
      withAuth: true
    });
    return response;
  } catch (error) {
    throw error;
  }
}